const Item = () => (
  <span className="flex items-center whitespace-nowrap">
    <span className="font-serif italic text-4xl sm:text-5xl md:text-6xl px-6">
      Hülya Suna Beauty
    </span>
    <span className="text-gold text-2xl">✦</span>
    <span className="eyebrow text-espresso/70 px-6 text-sm sm:text-base tracking-[0.3em]">
      Güzellik Rotanız
    </span>
    <span className="text-gold text-2xl">✦</span>
    <span className="font-serif italic text-4xl sm:text-5xl md:text-6xl px-6">
      Karatay • Konya
    </span>
    <span className="text-gold text-2xl">✦</span>
  </span>
);

export default function Marquee() {
  return (
    <section
      className="border-y border-espresso/10 bg-beige/40 py-6 overflow-hidden"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        <Item />
        <Item />
      </div>
    </section>
  );
}
